export function validAvailabilityDate(value: unknown): value is string {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value) || value.startsWith("0000-")) return false;
  const epoch = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(epoch) && new Date(epoch).toISOString().slice(0, 10) === value;
}
const validTime = (value: unknown): value is string => typeof value === "string" && /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value);
export function availabilityTimeError(from: unknown, to: unknown): string | null {
  if ((from == null || from === "") && (to == null || to === "")) return null;
  if (!validTime(from) || !validTime(to)) return "Podaj obie godziny w formacie HH:mm albo pozostaw oba pola puste dla całego dnia.";
  if (from === to) return "Godziny początku i końca muszą się różnić. Dla całego dnia pozostaw oba pola puste.";
  return null;
}
export function availabilityDateLabel(value: unknown): string {
  return validAvailabilityDate(value)
    ? `${value.slice(8, 10)}.${value.slice(5, 7)}.${value.slice(0, 4)}`
    : `Nieprawidłowa data: ${String(value ?? "brak")}`;
}
export function availabilityHoursLabel(from: unknown, to: unknown): string {
  if (availabilityTimeError(from, to)) return "Nieprawidłowe godziny";
  if (!from && !to) return "Cały dzień";
  return `${from}–${to}${String(to) < String(from) ? " (+1 dzień)" : ""}`;
}
